import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

import { GiHamburgerMenu } from "react-icons/gi";
import { FaSearch } from "react-icons/fa";
import { NavbarData } from "./NavbarData";
import { useCookies } from "react-cookie";

import "../index.css";

const Navbar = () => {
  const navigate = useNavigate();
  const { loggedIn, user, logout } = useAuth();
  const { status, id, type } = user;
  const [sidebar, setSidebar] = useState(false);
  const [username, setUsername] = useState("");
  const [cookies, removeCookie] = useCookies([]);

  const LOGGED_OUT_TEXT =
    "Create an account to post, comment, and leave a review and start taking part in the UPLBidets community!";

  const showSidebar = () => setSidebar(!sidebar);
  const handleLogout = () => {
    removeCookie("token");
    document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; sameSite=None;`;
    navigate("/login");
  };

  const fetchUsername = async (userId) => {
    try {
      const response = await fetch(`https://uplbidet-api.vercel.app/api/users/${userId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch username");
      }

      const userData = await response.json();
      setUsername(userData.username);
    } catch (error) {
      console.error("Error fetching username: ", error);
    }
  };

  useEffect(() => {
    if (status === true && id) {
      fetchUsername(id);
    }
  }, [id, status]);

  return (
    <>
      <div className="navbar">
        <div className="icon-container">
          {loggedIn ? (
            type === "admin" ? (
              <Link
                to="/admin"
                style={{ textDecoration: "none", color: "white" }}
              >
                <button>Admin Dashboard</button>
              </Link>
            ) : (
              <Link
                to={`/user-profile/${id}`}
                style={{ textDecoration: "none", color: "white" }}
              >
                <button>Hi, {username}</button>
              </Link>
            )
          ) : null}

          <Link to="/search" className="icon">
            <FaSearch />
          </Link>
        </div>
      </div>

      <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
        <div className="top">
          <Link to="#" className="nav-menu-toggle">
            <GiHamburgerMenu onClick={showSidebar} />
          </Link>
          <div className="nav-menu-logo">
            <Link to="/" className="menu-bars">
              <img
                src={require("../assets/logo.png")}
                alt="UPLBidets Logo"
                id="logo"
              ></img>
            </Link>
          </div>
        </div>

        <ul>
          {NavbarData.map((item, index) => {
            if (item.className.includes("dependent") && !loggedIn) {
              return null;
            }

            return (
              <li key={index}>
                {item.title === "Profile" && type === "admin" ? (
                  <Link to="/admin" className="nav-link">
                    <div className="nav-icon">{item.icon}</div>
                    <span className="nav-text">{item.title}</span>
                  </Link>
                ) : (
                  <Link
                    to={item.title === "Profile" ? item.path(id) : item.path}
                    className="nav-link"
                  >
                    <div className="nav-icon">{item.icon}</div>
                    <span className="nav-text">{item.title}</span>
                  </Link>
                )}

                <span id="tooltip" className="tooltip">
                  {item.title}
                </span>
              </li>
            );
          })}
        </ul>

        <div className={loggedIn ? "bottom active" : "bottom"}>
          <div className="log-description">
            <p>{LOGGED_OUT_TEXT}</p>
          </div>

          <div className="log-buttons">
            <Link to="/signup">
              <button className="sign-up">SIGN UP</button>
            </Link>
            <Link to="/login">
              <button className="log-in">LOG IN</button>
            </Link>
            <Link to="/login">
              <button className="log-out" onClick={handleLogout}>
                LOG OUT
              </button>
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
